/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Changes_TitleInputs */

const cs_ebr_changes_title = /** @type {(inputs: Ebr_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změny`)
};

const en_ebr_changes_title = /** @type {(inputs: Ebr_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes`)
};

/**
* | output |
* | --- |
* | "Changes" |
*
* @param {Ebr_Changes_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_changes_title = /** @type {((inputs?: Ebr_Changes_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Changes_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_changes_title(inputs)
	return cs_ebr_changes_title(inputs)
});